import { render, staticRenderFns } from "./StudyView.vue?vue&type=template&id=4249cfc8&scoped=true&"
import script from "./StudyView.vue?vue&type=script&lang=js&"
export * from "./StudyView.vue?vue&type=script&lang=js&"
import style0 from "./StudyView.vue?vue&type=style&index=0&id=4249cfc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4249cfc8",
  null
  
)

export default component.exports